
module.exports = {
    "global.project.center": "Project Center",
    "nav.samples": "Samples",
    "nav.tutorial": "Tutorial",
    "common.confirm": "Confirm",
    "common.cancel": "Cancel",
    "common.remove": "Remove",
    "common.operation": "Operation",
    "common.tip": "Tip",
    "common.role": "Role",
    "common.creator": "Creator",
    "common.project": "Project",
    "common.creation.time": "Creation Time",
    "common.developer": "Developer",
    "home.no.project.click": "Project list is empty, please click",
    "home.add.project": "Add Project",
    "home.add.first.project": "Add My First Project",
    "home.confirm.remove.user": "Confirm removing user",
    "home.project.name": "Poject Name",
    "home.project.description": "Poject Description",
    "home.add.user": "Add User",
    "home.username": "Username",
    "home.project.detail": "Project Detail",
    "home.release.management": "Release Management",
    "home.development.authorization": "Development Authorization",
    "home.enter.workbench": "Enter workbench",
    "home.my.role": "My Role",
    "home.developer.list": "Developer List",
    "home.add.member": "Add Member",
    "tip.input.project.name": "Please input project name",
    "tip.project.name.length": "The project name should be {{min}}-{{max}} characters",
    "tip.project.description.length": "The project description cannot exceed {{max}} characters",
    "tip.input.username": "Please input username",
    "tip.select.role": "Please select a role",
    "tip.no.results": "No results found",
    "delete": "Delete",
    "home.confirm.remove.project": "Are you sure to delete this project?",
    "myProject": "My Project",
    "deletedProject": "Deleted Project",
    "cloneProject": 'Clone Project',
    "grant": "Grant",
    "cloneInfo": "Clone Info",
    "clonedFrom": "Cloned From",
    "number": "Number",
    "removePermanent": "Are you sure to delete {{name}} permanently？",
    "startWithTest": "The project name can't start with test",
    "leave": "leave project"
}


// WEBPACK FOOTER //
// ./src/i18n/locale.en.js